<template>
	<div>
		<myheader headTitle="账号注销"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_content" style="padding-bottom: 3.8rem;">
				<div class="all_tips_content_card_padding8 all_text_center margin_bottom_10">
					<div class="margin_bottom_5">
						<img src="@/assets/images/redgantanhao1.svg" style="width: 5rem;height: 5rem;" />
					</div>
					<div class="text18 textcolor333 font_weight_bold margin_bottom_10">账号即将注销，请知晓以下几点</div>
					<div class="text12 textcolor333 margin_bottom_10 all_text_left">① 账号中的签约文件将被彻底删除，无法再次访问，请您确保已下载并备份；
					</div>
					<div class="text12 textcolor333 margin_bottom_5 all_text_left">② 账号中申请的个人CA证书、企业CA证书将被禁用，无法恢复；</div>
					<div class="text12 textcolor333 margin_bottom_5 all_text_left">③ 账号中维护的个人签名、企业印模将被彻底删除，无法恢复；</div>
					<div class="text12 textcolor333 margin_bottom_5 all_text_left">④ 注销后该账号的所有个人隐私信息将被彻底清除；</div>
					<div class="text12 textcolor333 margin_bottom_5 all_text_left">⑤ 注销后该账号将无法登录电子签约平台（石化e签）。</div>
					<div class="all_input all_height30" :class="{ isfocus: verifyFocus }">
						<div class="display_inline_block" style="width: 60%">
							<van-field v-model="verifyCode" type="number" maxlength="6" placeholder="请输入计算结果"
								@focus="getFocus(1)" @blur="onblur(1)" clearable>
							</van-field>
						</div>
						<span @click="getPictureImg()" class="display_inline_block" title="看不清,换一个" style="width: 35%;">
							<img :src="verifyImg" style="height: 1.8rem;width: 6rem;" fill title="看不清,换一个" /></span>
					</div>
					<div class="all_input all_height30" :class="{ isfocus: codeFocus }">
						<div class="display_inline_block" style="width: 60%;">
							<van-field v-model="smsCode" type="number" maxlength="6" placeholder="请输入验证码"
								@focus="getFocus(2)" @blur="onblur(2)" clearable />
						</div>
						<span @click="getCode()" class="display_inline_block text14 all_text_right all_line_height20"
							style="width: 35%;" :class="{textcolormain:timer===60,textcolor999:timer!=60}">
							{{timer===60?'获取验证码':(timer+'s后再次获取')}}</span>
					</div>
					<textarea class="area text12 textcolor333 margin_top_5" placeholder="请输入注销原因" v-model="denyWord"
						maxlength="100" style="overflow-y: auto;height: 3rem;">
						</textarea>
				</div>
				<div class="text12 margin_top_10 display_flex" style="text-align: left;">
					<div class="display_inline_block" style="width: 8%;">
						<van-checkbox v-model="checked"></van-checkbox>
					</div>
					<div class="display_inline_block" style="width: 92%;">
						我同意上述内容并承诺：已备份所有需要的合同文件，账号注销后不会对电子签约平台（石化e签）提出任何调阅合同、恢复数据的请求。</div>
				</div>
			</div>
			<div class="all_tips_bottom_card">
				<button class="all_button24 width_100 text16 backgroundC_ff0000" @click="sumbit()">确定注销</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Checkbox,
		Field,
		Dialog
	} from 'vant';
	import {
		resetRouter
	} from '../../router/index.js'
	export default {
		components: {
			[Checkbox.name]: Checkbox,
			[Field.name]: Field,
		},
		data() {
			return {
				//
				checked: false,
				//验证码倒计时
				timer: 60,
				//图片验证结果
				verifyCode: '',
				//验证Id
				verifyId: '',
				//验证图片
				verifyImg: '',
				//验证码
				smsCode: '',
				//
				denyWord: '',
				//
				codeFocus: false,
				verifyFocus: false,
			}
		},
		methods: {
			// 获得焦点
			getFocus(id) {
				if (id == 1) {
					this.verifyFocus = true;
				} else if (id == 2) {
					this.codeFocus = true;
				}
			},
			// 失去焦点
			onblur(id) {
				if (id == 1) {
					this.verifyFocus = false;
				} else if (id == 2) {
					this.codeFocus = false;
				}
			},
			//获取认证图片
			getPictureImg() {
				this.verifyCode = ''
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/login/api/getPictureImg').then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.verifyId = res.data.verifyId
						this.verifyImg = res.data.srcImg
					} else {
						this.verifyImg = ''
						this.$Toast("未获取到验证图片！");
					}
				}).catch((err) => {
					this.verifyImg = ''
					this.$store.dispatch(this.$LoadShow, false)
					console.log('getPictureImg', err)
				});
			},
			//
			getCode() {
				if (!this.verifyCode && !this.verifyId) {
					this.$Toast("请输入图像计算结果！");
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/my/api/sendSmsCode", JSON.stringify({
					mobile: this.$store.state.userInfo.mobile,
					type: 3, //type：1 登录、2 忘记密码、3 重置密码、4 更换手机号 5、个人认证
					verify: {
						id: this.verifyId,
						code: this.verifyCode
					}
				})).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast("验证码已发送，请注意查收！");
						this.timer--;
						var timer1 = setInterval(() => {
							this.timer--;
							if (this.timer == 0) {
								this.timer = 60;
								clearTimeout(timer1);
							}
						}, 1000);
					} else {
						this.$Toast(res.message || res.messageDetail || "获取验证码失败！");
						this.getPictureImg()
					}
				}).catch((err) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.getPictureImg()
					console.log('sendSmsCode', err)
				});
			},
			//
			sumbit() {
				let that = this
				if (!this.checked) {
					this.$Toast("请选中同意并承诺内容！");
					return
				}
				if (!this.smsCode) {
					this.$Toast("请输入验证码！");
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/my/api/unregister', {
					reason: this.denyWord,
					smsCode: this.smsCode
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						Dialog.alert({
							title: '提示',
							message: '注销成功',
						}).then(() => {
							window.localStorage.setItem("LoginInfo", '')
							window.localStorage.setItem("Identity_Token", '')
							that.$store.commit("changeLoginInfo", '')
							that.$store.commit("changeLoginToken", '')
							that.$store.dispatch("actionUserInfo", '');
							resetRouter()
							that.$router.push('/login')
						});
					} else {
						this.getPictureImg()
						Dialog.alert({
							title: '注销失败',
							message: res.message || res.messageDetail,
						}).then(() => {
							this.$Toast("注销失败，请重试！");
						});
					}
				}).catch((err) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast("注销失败，请重试！");
					this.getPictureImg()
					console.log('unregister', err)
				});
			},
			//
			init() {
				this.getPictureImg()
			},
		},
		mounted() {
			this.init()
		}
	}
</script>


<style scoped lang="scss">
	@import "../../styles/global.css";
</style>